import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-assignment-confirmation-modal',
  standalone: false,
  templateUrl: './assignment-confirmation-modal.component.html',
  styleUrls: ['./assignment-confirmation-modal.component.scss'],
})
export class AssignmentConfirmationModalComponent {
  @Input() public authorizerName: string;
  @Input() public isMobile = false;
  public readonly headerTitle =
    'WORKING_DAY.MODAL.CONFIRM_AUTHORIZER_MODAL.TITLE';

  public constructor(private readonly modalController: ModalController) {}

  public onDismissModal(accept?: boolean): void {
    this.modalController.dismiss(accept);
  }
}
